import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { FormikProps } from 'formik';
import { useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersFormErrorEvents } from 'system/pages/search-events-error/list/types';
import TypeEventList from 'system/components/published-events/type-event-list';
import TypeDestinationList from '../type-destination-list';
import SubscriberList from '../subscriber-list';
import StateList from '../state-list';
import PmiDateTimePicker from 'shell/components/shared/date-time-picker';
import { DateTime } from 'luxon';

interface FiltersErrorEventsProps {
  filterErrorEventsForm: FormikProps<FiltersFormErrorEvents>;
}

const FiltersErrorEvents = ({
  filterErrorEventsForm,
}: FiltersErrorEventsProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-error-events-content"
        id="panel-error-events-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterErrorEventsForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={9}>
              <TypeEventList
                value={filterErrorEventsForm.values.typeEventCode || ''}
                onChange={(e) =>
                  filterErrorEventsForm.setFieldValue('typeEventCode', e.target.value)
                }
                onBlur={() => filterErrorEventsForm.setFieldTouched('typeEventCode', true)}
                error={
                  filterErrorEventsForm.touched.typeEventCode &&
                  Boolean(filterErrorEventsForm.errors.typeEventCode)
                }
              />
            </Grid>
            <Grid item xs={12} md={9}>
              <TypeDestinationList
                value={filterErrorEventsForm.values.typeDestinationCode || ''}
                onChange={(e) =>
                  filterErrorEventsForm.setFieldValue('typeDestinationCode', e.target.value)
                }
                onBlur={() => filterErrorEventsForm.setFieldTouched('typeDestinationCode', true)}
                error={
                  filterErrorEventsForm.touched.typeDestinationCode &&
                  Boolean(filterErrorEventsForm.errors.typeDestinationCode)
                }
              />
            </Grid>
            <Grid item xs={12} md={9}>
              <SubscriberList
                value={filterErrorEventsForm.values.subscriber || ''}
                onChange={(e) => filterErrorEventsForm.setFieldValue('subscriber', e.target.value)}
                onBlur={() => filterErrorEventsForm.setFieldTouched('subscriber', true)}
                error={
                  filterErrorEventsForm.touched.subscriber &&
                  Boolean(filterErrorEventsForm.errors.subscriber)
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiDateTimePicker
                label="Data e ora pubblicazione da"
                aria-label="Data e ora pubblicazione da"
                defaultHour={DateTime.now().set({
                  hour: 0,
                  minute: 0,
                  second: 0,
                  millisecond: 0,
                })}
                value={filterErrorEventsForm.values.dateTimePublicationFrom || null}
                onChange={(date) => {
                  filterErrorEventsForm.setFieldValue('dateTimePublicationFrom', date);
                }}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="dateTimePublicationFrom"
                    error={
                      filterErrorEventsForm.touched.dateTimePublicationFrom &&
                      Boolean(filterErrorEventsForm.errors.dateTimePublicationFrom)
                    }
                    helperText={filterErrorEventsForm.errors.dateTimePublicationFrom}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <PmiDateTimePicker
                label="Data e ora pubblicazione a"
                aria-label="Data e ora pubblicazione a"
                value={filterErrorEventsForm.values.dateTimePublicationTo || null}
                onChange={(date) =>
                  filterErrorEventsForm.setFieldValue('dateTimePublicationTo', date)
                }
                defaultHour={DateTime.now().set({
                  hour: 23,
                  minute: 59,
                  second: 59,
                  millisecond: 0,
                })}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="dateTimePublicationTo"
                    error={
                      filterErrorEventsForm.touched.dateTimePublicationTo &&
                      Boolean(filterErrorEventsForm.errors.dateTimePublicationTo)
                    }
                    helperText={filterErrorEventsForm.errors.dateTimePublicationTo}
                    fullWidth
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <StateList
                value={filterErrorEventsForm.values.state || ''}
                onChange={(e) => filterErrorEventsForm.setFieldValue('state', e.target.value)}
                onBlur={() => filterErrorEventsForm.setFieldTouched('state', true)}
                error={
                  filterErrorEventsForm.touched.state && Boolean(filterErrorEventsForm.errors.state)
                }
              />
            </Grid>
            <Grid item xs={12} md={6}></Grid>
            <Grid item xs={3}>
              <PmiButton variant="contained" color="secondary" type="submit">
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersErrorEvents.displayName = 'Filters Error Events component';

export default FiltersErrorEvents;
